import { Flex, Loader, Modal } from '@mantine/core';
import { useDoseSpotIFrame } from '@medplum/dosespot-react';
import { useEffect, useState } from 'react';
import { notifications } from '@mantine/notifications';

export default function DosespotConfigModal({ opened, onClose }: { opened: boolean; onClose: () => void }) {
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const iframeUrl = useDoseSpotIFrame({
    onIframeSuccess: () => {
      setIsLoading(false);
    },
    onError: (_error) => {
      setErrorMessage("Couldn't load DoseSpot configuration");
    },
  });

  useEffect(() => {
    if (opened && errorMessage) {
      notifications.show({
        title: "Couldn't load DoseSpot configuration.",
        message: errorMessage,
        color: 'red',
        autoClose: 3000,
      });
    }
  }, [opened, errorMessage]);

  const renderContent = () => {
    if (isLoading) {
      return (
        <Flex justify="center" align="center" h="70vh">
          <Loader />
        </Flex>
      );
    }

    return (
      iframeUrl && (
        <iframe
          src={iframeUrl}
          style={{ width: '100%', height: '100%', border: 'none', display: 'block' }}
          title="DoseSpot Config"
        />
      )
    );
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      size="100%"
      padding={0}
      styles={{
        content: { height: '98vh', display: 'flex', flexDirection: 'column' },
        header: { padding: '0.25rem 0.75rem', minHeight: 36 },
        title: { fontSize: '0.9rem' },
        close: { width: 28, height: 28 },
        body: { flex: 1, padding: '0.25rem 0.5rem' },
      }}
      title="Dosespot Config"
    >
      {renderContent()}
    </Modal>
  );
}
